import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from 'ngx-toastr';
import { ToastrModule } from 'ngx-toastr';
export * from 'ngx-toastr';

class ToasterService {
    constructor(_toastrService) {
        this._toastrService = _toastrService;
    }
    success(msg, title, config) {
        this._toastrService.success(msg, title, Object.assign({ closeButton: true }, config));
    }
    info(msg, title, config) {
        return this._toastrService.info(msg, title, Object.assign({ closeButton: true }, config));
    }
    warning(msg, title, config) {
        this._toastrService.warning(msg, title, Object.assign({ disableTimeOut: true, closeButton: true }, config));
    }
    error(msg, title, config) {
        this._toastrService.error(msg, title, Object.assign({ disableTimeOut: true, closeButton: true }, config));
    }
    clear(toastId) {
        this._toastrService.clear(toastId);
    }
}
ToasterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToasterService, deps: [{ token: i1.ToastrService }], target: i0.ɵɵFactoryTarget.Injectable });
ToasterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToasterService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToasterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.ToastrService }]; } });

class ToasterModule {
}
ToasterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToasterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ToasterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToasterModule, imports: [i1.ToastrModule] });
ToasterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToasterModule, imports: [[
            ToastrModule.forRoot({
                preventDuplicates: true,
                positionClass: 'toast-top-center',
            }),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ToasterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        ToastrModule.forRoot({
                            preventDuplicates: true,
                            positionClass: 'toast-top-center',
                        }),
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ToasterModule, ToasterService };
